let filter = {
  fix2: (val) => {
    //let ratio = sessionStorage.getItem('ratio')
    let ratio = global.ratio
    return val ? (val*ratio).toFixed(2) : '0'
  },
  fix0: (val) => {
    //let ratio = sessionStorage.getItem('ratio')
    let ratio = global.ratio
    return  val ? (val*ratio).toFixed(0) : '0'
  },
  format: (value) => {
    if (!value) return 0
    return value > 10000 ? (value / 10000).toFixed(2) : value
  }
}

export default filter


// WEBPACK FOOTER //
// ./src/common/filter.js